module.exports = __webpack_public_path__ + "files/7080863bd4675e6c2c65c88f91f96a4e.png";